import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';
import { Helmet } from "react-helmet";

import './Resources/dashboard.css';
import axios from '../axios.js';
import Navbar from './Supportingfiles/navbar.js';
import Sidebar from './Supportingfiles/sidebar';
//import Create_customers from './create_customers';
import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';


import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";


//EXCEL DOWNLOAD IMPORT
//import * as XLSX from 'xlsx';
//import { saveAs } from 'file-saver';

function Team_dashboard(){




    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");

 
 useEffect(()=>{
   
  getData();
  
  },[])
 



 // const[teams_count,setteams_count]=useState(0);
 // const[team_members_count,setteam_members_count]=useState(0);
  const[users_count,setusers_count]=useState(0);
  const[documents_count,setdocuments_count]=useState(0);
  const[companies_count,setcompanies_count]=useState(0);
  const[projects_count,setprojects_count]=useState(0);
 
 //ERROR VARIABLES 
 const[error_msg,seterror_msg]=useState();
 const[errorvar,seterrorvar]=useState();


//******************* DASHBOARD DEFAULT LOAD FUNCTION START  ********************//
function getData(){

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 axios.post("team-dashboard-default-load", {
   Log_id:logid,
   Token:token,
   Filter_val:0

   })
 .then((response) => {


  //  console.log(response.data);

  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
  // setteams_count(response.data.teams_count);
  // setteam_members_count(response.data.team_members_count);
   setusers_count(response.data.users_count);
   setdocuments_count(response.data.documents_count);
   setcompanies_count(response.data.companies_count);
   setprojects_count(response.data.projects_count);
    }

  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");

   window.location.replace("/");
 
  }

 }
  
 //******************* DASHBOARD DEFAULT LOAD FUNCTION END  ********************//



 

return(
    <>
      <Helmet>
            <meta name="robots" content="noindex,nofollow" />
      </Helmet>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN | DOCUMENT MANAGEMENT SYSTEM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

          <div className="row">
              <div className="col-12 grid-margin create-form" id="create-form">
             {/*} <Create_cash /> */}
              </div>
          </div>


            <div className="page-header flex-wrap">
            <div className="header-left">  
           
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">TEAM PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">DASHBOARD</p>
                  </a>
                </div>
             {/*}   <button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text"  onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i className="mdi mdi-plus-circle"></i> </button> */}
              </div>
            </div>

            {/*} chart row starts here */}
            <div className="row">

          
            </div>

             {/* TOP BAR */}
               <div class="row">
             
              {/*}  <div class="card card-stat stretch-card mb-3">
                  <div class="card-body col-md-4">
                    <div class="d-flex justify-content-between">
                      <div class="text-white" style={{textAlign:"left"}}>
                        <h3 class="font-weight-bold mb-0">{documents_count}</h3>
                        <h6>Documents</h6>
                      {/*}  <div class="badge badge-success">+ ₹ {sum_today_orders_payment}</div> */}
                     {/*} </div>
                      <div class="flot-bar-wrapper">
                        <div id="column-chart" class="flot-chart"></div>
                      </div>
                    </div>
                  </div>
                </div>*/}
                <div class="card mb-3 col-md-3" style={{textAlign:"left"}}>
                  <div class="card-body d-flex flex-wrap justify-content-between">
                    <div>
                      <h4 class="font-weight-semibold mb-1 text-black"> Users </h4>
                      <h6 class="text-muted">total users count</h6>
                    </div>
                    <h3 class="text-primary font-weight-bold">{users_count}</h3>
                    <br/>
                   {/*} <p class="text-success" hidden={today_trainings_count == 0}>+ {today_trainings_count} <span hidden={today_orders_count>0}>0</span> today</p>*/}
                  </div>
                </div>
                <div class="card mb-3 col-md-3" style={{textAlign:"left"}}>
                  <div class="card-body d-flex flex-wrap justify-content-between">
                    <div>
                      <h4 class="font-weight-semibold mb-1 text-black"> Companies </h4>
                      <h6 class="text-muted">total companies</h6>
                    </div>
                    <h3 class="text-primary font-weight-bold">{companies_count}</h3>
                    <br/>
                   {/*} <p class="text-success" hidden={sum_today_payments == 0}>+ {sum_today_payments} <span hidden={today_orders_count>0}>0</span> today</p>*/}
                  </div>
                </div>
                <div class="card mb-3 col-md-3" style={{textAlign:"left"}}>
                  <div class="card-body d-flex flex-wrap justify-content-between">
                    <div>
                      <h4 class="font-weight-semibold mb-1 text-black"> Projects</h4>
                      <h6 class="text-muted">total projects</h6>
                    </div>
                    <h3 class="text-primary font-weight-bold">{projects_count}</h3>
                    <br/>
                   {/*} <p class="text-success" hidden={sum_today_payments == 0}>+ {sum_today_payments} <span hidden={today_orders_count>0}>0</span> today</p>*/}
                  </div>
                </div>
                 <div class="card mb-3 col-md-3" style={{textAlign:"left"}}>
                  <div class="card-body d-flex flex-wrap justify-content-between">
                    <div>
                      <h4 class="font-weight-semibold mb-1 text-black"> Documents</h4>
                      <h6 class="text-muted">total documents</h6>
                    </div>
                    <h3 class="text-primary font-weight-bold">{documents_count}</h3>
                    <br/>
                   {/*} <p class="text-success" hidden={sum_today_payments == 0}>+ {sum_today_payments} <span hidden={today_orders_count>0}>0</span> today</p>*/}
                  </div>
                </div>

              </div>
             

            {/* DASHBOARD SECTION START */}
            <div class="row d-flex justify-content-center">

            <h2>DASHBOARD</h2>
                 
              {/* Card 1 Start */}
              <div class="col-sm-4 stretch-card grid-margin">
              <div class="card">
                  <div class="card-body p-0" style={{borderBottom:"0.2rem solid #0c4489"}}>
                   <img src="https://cdn.vectorstock.com/i/500p/01/85/training-courses-isometric-icons-vector-23210185.avif"  style={{maxHeight:"40vh", minHeight:"40vh"}} class="img-fluid w-100"  alt="Image" /> 
                  </div>
                  <div class="card-body px-3 text-dark">
                   {/*} <div class="d-flex justify-content-between">
                      <p class="text-muted font-13 mb-0">My Profile</p>
                      <button class="btn btn-primary">Manage Profile</button>
                    </div> */}
                    <h5 class="font-weight-semibold" style={{textAlign:"left"}}>USERS</h5>
                    <p style={{textAlign:"left"}}>manage users from here</p>
                    <p style={{textAlign:"left"}}><a href="/teampanel-users"><button class="btn btn-primary">Manage Users</button></a></p>
                   {/*} <div class="d-flex justify-content-between font-weight-semibold">
                    <button type="submit" class="btn btn-outline-primary mb-0">view</button>
                    <p class="mb-0 text-info"><b>₹ 50000</b></p>
                    </div> */}
                  </div>
                </div>
              </div>     
              {/* Card 1 End */}


              {/* Card 2 Start */}
              <div class="col-sm-4 stretch-card grid-margin">
              <div class="card">
                  <div class="card-body p-0" style={{borderBottom:"0.2rem solid #0c4489"}}>
                   <img src="https://cdn.vectorstock.com/i/preview-2x/56/56/tax-payment-concept-income-form-document-vector-40555656.webp" class="img-fluid w-100"  style={{maxHeight:"40vh", minHeight:"40vh"}}  alt="Image" /> 
                  </div>
                  <div class="card-body px-3 text-dark">
                   {/*} <div class="d-flex justify-content-between">
                      <p class="text-muted font-13 mb-0">My Profile</p>
                      <button class="btn btn-primary">Manage Profile</button>
                    </div> */}
                    <h5 class="font-weight-semibold" style={{textAlign:"left"}}>DOCUMENTS</h5>
                    <p style={{textAlign:"left"}}>manage documents from here </p>
                    <p style={{textAlign:"left"}}><a href="/teampanel-all-documents"><button class="btn btn-primary">Manage Documents</button></a></p>
                   {/*} <div class="d-flex justify-content-between font-weight-semibold">
                    <button type="submit" class="btn btn-outline-primary mb-0">view</button>
                    <p class="mb-0 text-info"><b>₹ 50000</b></p>
                    </div> */}
                  </div>
                </div>
              </div>     
              {/* Card 2 End */}

              {/* Card 3 Start */}
              <div class="col-sm-4 stretch-card grid-margin">
              <div class="card">
                  <div class="card-body p-0" style={{borderBottom:"0.2rem solid #0c4489"}}>
                   <img src="https://cdn.vectorstock.com/i/500p/98/34/online-meeting-registration-vector-36269834.avif" class="img-fluid w-100"  style={{maxHeight:"40vh", minHeight:"40vh"}}  alt="Image" /> 
                  </div>
                  <div class="card-body px-3 text-dark">
                   {/*} <div class="d-flex justify-content-between">
                      <p class="text-muted font-13 mb-0">My Profile</p>
                      <button class="btn btn-primary">Manage Profile</button>
                    </div> */}
                    <h5 class="font-weight-semibold" style={{textAlign:"left"}}>COMPANIES</h5>
                    <p style={{textAlign:"left"}}>view companies from here</p>
                    <p style={{textAlign:"left"}}><a href="/teampanel-companies"><button class="btn btn-primary">View Companies</button></a></p>
                   {/*} <div class="d-flex justify-content-between font-weight-semibold">
                    <button type="submit" class="btn btn-outline-primary mb-0">view</button>
                    <p class="mb-0 text-info"><b>₹ 50000</b></p>
                    </div> */}
                  </div>
                </div>
              </div>     
              {/* Card 3 End */}

           
             
              {/* Card 4 Start */}
              <div class="col-sm-4 stretch-card grid-margin">
              <div class="card">
                  <div class="card-body p-0" style={{borderBottom:"0.2rem solid #0c4489"}}>
                   <img src="https://cdn.vectorstock.com/i/500p/84/12/education-class-students-and-teacher-vector-30338412.avif" class="img-fluid w-100"  style={{maxHeight:"40vh", minHeight:"40vh"}}  alt="Image" /> 
                  </div>
                  <div class="card-body px-3 text-dark">
                   {/*} <div class="d-flex justify-content-between">
                      <p class="text-muted font-13 mb-0">My Profile</p>
                      <button class="btn btn-primary">Manage Profile</button>
                    </div> */}
                    <h5 class="font-weight-semibold" style={{textAlign:"left"}}>PROJECTS</h5>
                    <p style={{textAlign:"left"}}>view all your projects from here </p>
                    <p style={{textAlign:"left"}}><a href="/teampanel-projects"><button class="btn btn-primary">View Projects</button></a></p>
                   {/*} <div class="d-flex justify-content-between font-weight-semibold">
                    <button type="submit" class="btn btn-outline-primary mb-0">view</button>
                    <p class="mb-0 text-info"><b>₹ 50000</b></p>
                    </div> */}
                  </div>
                </div>
              </div>     
              {/* Card 4 End */}

           
            
            </div>
          {/* DASHBOARD SECTION END */}
          


           <br/><br/><br/>
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Team_dashboard;